module.exports = __webpack_public_path__ + "static/Bigideasummary-8fe563ead53df41e8ede0e1ae8efc9d1.png";